export { default as Toasterer } from './toasterer'



// WEBPACK FOOTER //
// ./src/app/shared/components/toasterer/index.ts